module.exports = __webpack_public_path__ + "static/media/4.dfc88669.png";